import { mainMenu, dropdownMenu } from "./menu";
import headerInit from "./header";
import { ready } from "./utils";
import { emblaSliders } from './sliders';
import { loopAnimations } from "./animations";
import { loadMorePosts } from "./load-more";

ready(() => {
  mainMenu();
  dropdownMenu();
  headerInit();
  emblaSliders();
  loopAnimations();
  loadMorePosts();
});
